<template>
  <a-upload v-model:file-list="info.fileList" list-type="picture-card"
            :data="(f:UploadFile) => session.ossSign(f,1024*1024)"
            accept=".jpg,.jpeg,.png" :max-count="max"
            action="https://activity-guandb-cn.oss-cn-shanghai.aliyuncs.com"
            :show-upload-list="{showRemoveIcon:true,showDownloadIcon:false}" :is-image-url="isImageUrl"
            @change="onUploadChange" @preview="handlePreview" v-bind="$attrs">
    <div v-if="info.fileList.length < max || showUploadButton">
      <plus-outlined/>
      <div style="margin-top: 8px">{{ title ?? '上传' }}</div>
    </div>
  </a-upload>
  <a-modal v-model:open="info.preview.visible" :title="info.preview.title" :footer="null" @cancel="handleCancel">
    <img v-if="info.preview.image.split('.').pop() != 'mp4'" :alt="info.preview.title" :src="info.preview.image"
         style="width: 100%"/>
    <video v-else :src="info.preview.image" controls style="width: 100%"/>
  </a-modal>
</template>

<script setup lang="ts">

import {onMounted, reactive, watch} from "vue";
import {UploadFile, UploadProps} from "ant-design-vue";
import {PlusOutlined} from "@ant-design/icons-vue";
import {session} from "@/model/session";

const props = defineProps<{
  images: string[],
  max: number,
  imageSizeLimit?: string,
  title?: string,
  showUploadButton?: boolean
}>()
const emits = defineEmits(['update:images', 'change'])

const info = reactive({
  fileList: [] as UploadFile[],
  preview: {visible: false, title: '', image: ''}
})

onMounted(() => {
  info.fileList = props.images.map(i => ({
        status: 'done', url: i,
        thumbUrl: i.endsWith('mp4') ? require('@/assets/image/mp4.png') : `${i}-sq.200`
      } as UploadFile)
  )
  watch(() => props.images, () => {
    info.fileList = props.images.map(i => {
      return {
        status: 'done',
        url: i,
        thumbUrl: i.endsWith('mp4') ? require('@/assets/image/mp4.png') : `${i}-sq.200`
      } as UploadFile
    })
  })
})


const isImageUrl = (f: UploadFile): boolean => {
  return (f.thumbUrl?.endsWith('-sq.200') ?? true) || (f.thumbUrl?.startsWith('data:image') ?? true);
}

const onUploadChange = (j: Record<string, UploadFile>) => {
  const f = j.file
  if (f.status == 'done') {
    if (f.url?.endsWith('mp4')) f.thumbUrl = require('@/assets/image/mp4.png')
    else f.thumbUrl = f.url + '-sq.200'
    emits('update:images', info.fileList.map(i => i.url))
    emits('change', info.fileList.map(i => i.url))
  } else if (f.status == 'removed') {
    emits('update:images', info.fileList.map(i => i.url))
    emits('change', info.fileList.map(i => i.url))
  } else if (f.status == undefined) {
    info.fileList.pop()
  }
}

function getBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

const handleCancel = () => {
  info.preview.visible = false;
  info.preview.title = '';
}

const handlePreview = async (file: UploadProps['fileList'][number]) => {
  if (!file.url && !file.preview) {
    file.preview = (await getBase64(file.originFileObj)) as string;
  }
  info.preview.image = file.url || file.preview;
  info.preview.visible = true;
  info.preview.title = '';
};

</script>

<style scoped lang="sass">
.ant-upload-list-item-image
  object-fit: cover
</style>